export default __webpack_public_path__ + "static/1244-ce5a42da223206ee6ab27a3be9474f9e.gif";